<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    div(class="outsety-4")
        ib-row
            ib-col(class="s12 m12 l12 xl6")
                ib-form(@submit="findTicker")
                    ib-field(
                        class="search-field",
                        v-model="curSearch",
                        @input="checkValidation(curSearch)",
                        :uppercase="true",
                        :placeholder="this.$t('search_by_ticker')"
                    )
                    span(@click="clearField", class="bg15-inverse cancel")
                        +icon-basic-cancel
                    button(@click="findTicker", class="magnify")
                        +icon-basic-search_filled
</template>
<script>

    export default {
        name: 'SearchTerm',
        props: {
            'contracts': Array
        },
        data() {
            return {
                curSearch: '',
                invalidInput: false,
            }
        },
        methods: {
            checkValidation(val) {
                this.invalidInput = /[^a-zA-Z\d\s\.]/g.test(val) ? true : false;
            },

            clearField() {
                this.curSearch = '';
                this.$emit('clearRes');
            },

            findTicker() {
                if (this.invalidInput) {
                    $alert(this.$t('valid_symbol'));
                    this.clearField();
                    return;
                }
                this.curSearch = this.curSearch.toUpperCase();
                const res = this.contracts.filter(contract => contract.ticker === this.curSearch);
                if (res.length === 0) {
                    $alert(this.$t('ticker_exist'));
                    this.curSearch = '';
                } else {
                    this.$emit('searchRes', res);
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .search-field {
        width: calc(100% - 62px);
        margin: 0 0 20px 0;
        border-color: rgba(0,0,0,0.2);
        &:hover {
            border-color: #000;
        }
    }
    .cancel {
        display: inline-block;
        height: 31px;
        padding: 4px;
        margin-left: -3px;
        margin-bottom: 8px;
        width: 31px;
        border: 1px solid #d7d7d7;
        svg {
            color: #dcdcde;
        }
    }
    .magnify {
        height: 31px;
        width: 31px;
        border: 1px solid #D7D7D7;
        border-radius: 0 5px 5px 0px;
        background-color: #F7F7F7;
        position: relative;
        margin-bottom: 8px;
        border-left: 0;
        svg {
            width: 100%;
            height: 1em;
        }
    }
</style>